import React, { useEffect, useState } from 'react';

const EmojiPicker = ({ onSelect, position }) => {
  const emojis = ['❤️', '👍', '😂', '😮', '😢', '🔥'];
  const [adjustedPosition, setAdjustedPosition] = useState(position);

  useEffect(() => {
    // Adjust position to keep picker on screen
    const pickerWidth = 300; // Approximate width
    const pickerHeight = 70;
    const padding = 10;

    let x = position.x - (pickerWidth / 2); // Center horizontally
    let y = position.y - pickerHeight - padding;

    // Keep within horizontal bounds
    if (x < padding) x = padding;
    if (x + pickerWidth > window.innerWidth - padding) {
      x = window.innerWidth - pickerWidth - padding;
    }

    // Keep within vertical bounds (show above if possible, below if needed)
    if (y < padding) {
      y = position.y + padding; // Show below instead
    }

    setAdjustedPosition({ x, y });
  }, [position]);

  return (
    <div 
      className="fixed z-50 bg-white rounded-full shadow-2xl border-2 border-gray-200 px-2 py-2 flex space-x-1 animate-bounce-in"
      style={{
        top: `${adjustedPosition.y}px`,
        left: `${adjustedPosition.x}px`,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {emojis.map((emoji) => (
        <button
          key={emoji}
          onClick={() => onSelect(emoji)}
          className="text-2xl sm:text-3xl hover:scale-125 transition-transform active:scale-110 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full hover:bg-gray-100"
        >
          {emoji}
        </button>
      ))}
    </div>
  );
};

export default EmojiPicker;
